import { createConfirmation } from "react-confirm";
import AddExtraGroupDialog from "./AddExtraGroupDialog";

export const showAddExtraGroupDialog = createConfirmation(AddExtraGroupDialog);
